import axios from '../axios'
// 书本查询
export const getBookList = (data) => {
  return axios({
    url: '/con/book/listBooks',
    method: 'POST',
    data: data
  })
}
export const postUpdateBook = (data) => {
  return axios({
    url: '/con/book/updateBookStatus',
    method: 'POST',
    data: data
  })
}
// 添加书本
export const postAddBook = (data) => {
  return axios({
    url: '/con/book/updateBook',
    method: 'POST',
    data: data
  })
}
// 查询书本推荐管理列表
export const getBookRecommendList= (data) => {
  return axios({
    url: '/con/book/listBookRecommend',
    method: 'POST',
    data: data
  })
}
// 删除书本推荐
export const postDeleteBookRecommend= (data) => {
  return axios({
    url: '/con/book/deleteBookRecommend',
    method: 'POST',
    data: data
  })
}
// 添加书本推荐
export const postAddRecommend= (data) => {
  return axios({
    url: '/con/book/addBookRecommend',
    method: 'POST',
    data: data
  })
}
// 添加书本推荐
export const postBookSort= (data) => {
  return axios({
    url: '/con/book/moveBookRecommendSequence',
    method: 'POST',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/book.js